import React from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';

const WeValueLeraning = props => {
  return (
    <>
      <Head>
        <title>We Value Learning | Our Commitment to Growth - WeProdigi</title>
        <meta
          name="description"
          content="Explore how WeProigi values the culture of continuous learning through knowledge sharing and networking. We encourage our employees to grow and innovate."
        />

        <meta property="og:url" content="https://weprodigi.com/about-us/we-value-learning" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="We Value Learning | Our Commitment to Growth - WeProdigi" />
        <meta
          property="og:description"
          content="Explore how WeProigi values the culture of continuous learning through knowledge sharing and networking. We encourage our employees to grow and innovate."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/metas/meta-learning.png" />
      </Head>
      <main>
        <style global jsx>{`
          .bg-image {
            background-size: cover;
            background-image: url('/images/about/learnDesktop.png');
            background-position: center;
          }
          .bg-image-light {
            background-size: cover;
            background-image: url('/images/about/learnDesktop.png');
            background-position: center;
          }
          @media screen and (max-width: 758px) {
            .bg-image {
              background-image: url('/images/about/learnMobile.png');
            }
            .bg-image-light {
              background-image: url('/images/about/Group3228.png');
            }
          }
        `}</style>
        <div className="relative w-full  h-700  overflow-hidden  bg-image">
          <div className="container h-full">
            <h1 className="relative h-full  flex flex-col flex-wrap justify-center items-start ">
              <div className="uppercase text-white text-30 md:text-72 font-black leading-none">We Value</div>
              <div className="uppercase text-green text-30 md:text-72 font-black ">Learning</div>
            </h1>
          </div>
        </div>
        <div className="body-part">
          <div className="bg-white">
            <div className="container py-30">
              More than 100 years have passed since Frederick Taylor published his principles of scientific management. Back then, employees were
              limited in choices and treated as productive machines with alienated spirits. Fast forward to the present, we are breaking those
              principles giving more space for employees for self-development, knowledge acquisition, and all the power to grow and evolve.
              Employability, the ability to gain and maintain a desired job, now depends more on employees' desire to learn new skills rather than on
              expertise they already have. Putting forward employees’ willingness and learnability, we still appreciate and encourage their
              initiatives and value academic qualifications as a solid base for further development. We accept employees as the most valuable asset
              and part of core values investing in their education and developing corporate learning in several directions.
            </div>
          </div>

          <div className="bg-gray-light">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none  font-black uppercase">We Nurture learning</h2>
              <div className="mt-20">
                We hold regular knowledge sharing and team building sessions that are to answer the following questions: “What is the last book you
                read that opened your mind? (Simply reading the articles your Facebook friends share doesn’t count.) When did you last devote time to
                study another industry? How hard do you try to break your default routine at work? How often do you ask “why”?”. Even a piece of new
                information shared with team members is invaluable. Little by little, drop by drop, we fill the ocean of knowledge.
              </div>
              {/*<div className="mt-30">*/}
              {/*    <CertificatesSlider certificates={[*/}
              {/*        "/images/about/Anahit_V1.png",*/}
              {/*        "/images/about/Anahit_V1.png",*/}
              {/*        "/images/about/Anahit_V1.png",*/}
              {/*        "/images/about/Anahit_V1.png",*/}
              {/*        "/images/about/Anahit_V1.png",*/}
              {/*    ]}*/}
              {/*    />*/}
              {/*</div>*/}
            </div>
          </div>

          <div className="bg-image-light w-full min-h-171">
            <div className="container max-w-800 flex  h-171 flex-col justify-center items-center text-white font-500 text-18 md:text-24 text-center">
              <div className=""> “Anyone who stops learning is old, whether at twenty or eighty. Anyone who keeps learning stays young.”</div>
              <div className="text-16 self-end">- Henry Ford</div>
            </div>
          </div>
          <div className="bg-gray-light">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none  font-black uppercase">We Reward knowledge</h2>
              <div className="flex flex-wrap justify-between mt-20">
                <div className="w-full md:w-half-auto">
                  <p>
                    To nurture and motivate continuous learning, it is not enough to hire curious people and hope they display as much learnability as
                    expected. We realize that rewarding is the best means of motivation.
                  </p>
                  <p>
                    Rewards, everyone loves them. Be it feedback or material prize, we do love being rewarded. We provide new and challenging
                    opportunities for those self-directed and motivated learners to acquire knowledge and be rewarded by broadening their expertise
                    and increasing value to the company and themselves. We hold regular events and activities to promote learnability in our company:
                    gather around a conference, host guest speakers, and share information that is intellectually stimulating and has the potential to
                    nurture employees’ curiosity. Even rewarding the tiniest efforts like writing a blog, sharing articles on social media, or
                    recommending books and movies we create a unique atmosphere and culture acting as catalysts of employees’ learnability.
                  </p>
                </div>
                <div className="w-full md:w-half-auto mt-30  md:mt-0">
                  <picture className="">
                    <source srcSet="/images/about/sales_group_images1.png" type="image/png" />
                    <img src="/images/about/sales_group_images1.png" alt="discover image" width="541" height="327" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white">
            <div className="container py-30">
              <h2 className="titple text-purple text-24  leading-none font-black uppercase">We Focus on real-world situations</h2>
              <p className=" mt-20">
                People eagerly participate in learning, remembering new skills, and sharing knowledge if involved in real-world situations. We create
                the best environment where our specialists can test, use and analyze the new skills they have learned, and give them the power of
                making mistakes and not be scared of them.
              </p>
            </div>
          </div>
          <div className="bg-gray-light">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none  font-black uppercase">We Encourage networking</h2>
              <p className=" mt-20">
                Whether internal or external, we encourage the networking of employees as a means of knowledge sharing. Those groups are valuable
                assets within the organization and a talent pool for future team growth.
              </p>
            </div>
          </div>
          <div className="bg-white">
            <div className="container py-30">
              <h2 className="titple text-purple text-24 leading-none  font-black uppercase">We give Mentorship opportunities</h2>
              <p className=" mt-20">
                {' '}
                Continuous learning and growth are possible if led by knowledgeable mentors. We connect new talents and learners with experience to
                fill the knowledge gap. A friendly environment and regular contact with mentors give employees a space to speak openly about their
                learning and growth challenges.
              </p>
              <p className=" font-bold">Knowledge is the most valuable and permanent asset we will always choose for investment.</p>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
export default WeValueLeraning;
